/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboForexManagementBadRequestResponse,
  BboForexManagementFailureResponseResponse,
  BboForexManagementForbiddenResponse,
  BboForexManagementUnauthorizedResponse,
  BranchForexOverviewResponseResponse,
  NotFoundResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get cumulative Forex details across all accounting location with association details as well. Endpoint will get declared forex details (current variance and to date variance) for all accounting locations. It will respond will data segregated based on counter                     association with cash drawers.
 * @summary Get cumulative Forex details across all accounting location with association details as well.
 */
export const getForexBranchOverviewDetails = (signal?: AbortSignal) => {
  return customInstance<BranchForexOverviewResponseResponse>({
    url: `/BboForexManagementService/v1/branch-overview`,
    method: 'get',
    signal,
  });
};

export const getGetForexBranchOverviewDetailsQueryKey = () => {
  return [`/BboForexManagementService/v1/branch-overview`] as const;
};

export const getGetForexBranchOverviewDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getForexBranchOverviewDetails>>,
  TError = ErrorType<
    | BboForexManagementBadRequestResponse
    | BboForexManagementUnauthorizedResponse
    | BboForexManagementForbiddenResponse
    | NotFoundResponse
    | BboForexManagementFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getForexBranchOverviewDetails>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetForexBranchOverviewDetailsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getForexBranchOverviewDetails>>> = ({
    signal,
  }) => getForexBranchOverviewDetails(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getForexBranchOverviewDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetForexBranchOverviewDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getForexBranchOverviewDetails>>
>;
export type GetForexBranchOverviewDetailsQueryError = ErrorType<
  | BboForexManagementBadRequestResponse
  | BboForexManagementUnauthorizedResponse
  | BboForexManagementForbiddenResponse
  | NotFoundResponse
  | BboForexManagementFailureResponseResponse
>;

/**
 * @summary Get cumulative Forex details across all accounting location with association details as well.
 */
export const useGetForexBranchOverviewDetails = <
  TData = Awaited<ReturnType<typeof getForexBranchOverviewDetails>>,
  TError = ErrorType<
    | BboForexManagementBadRequestResponse
    | BboForexManagementUnauthorizedResponse
    | BboForexManagementForbiddenResponse
    | NotFoundResponse
    | BboForexManagementFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getForexBranchOverviewDetails>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetForexBranchOverviewDetailsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
